import React from 'react';

// Shared nav-icon set still consumed by MCPlaybackSidebar (the tablet-landscape sidebar). The rail itself
// no longer renders these — it reuses MobileBottomNav — but the export stays until the tablet sidebar is
// reworked (David: tablet/desktop playback styling to be torn down + rebuilt later), so tablet keeps
// building unchanged. #86bb7phhh.
export const NAV_ICONS = {
  live: (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z" />
    </svg>
  ),
  playback: (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm4.2 14.2L11 13V7h1.5v5.2l4.5 2.7-.8 1.3z" />
    </svg>
  ),
  mcplayback: (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M3 3h8v8H3V3zm10 0h8v8h-8V3zM3 13h8v8H3v-8zm10 0h8v8h-8v-8z" />
    </svg>
  ),
  more: (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
    </svg>
  ),
};

/**
 * MCPlaybackRail — the mobile-LANDSCAPE right rail.
 *
 * Landscape hides the topbar AND the bottom nav (the existing phone-landscape query, commonStyle.css:474)
 * to reclaim vertical space for video; this rail REPLACES both. Rendered always; CSS-hidden except at that
 * same phone-landscape breakpoint (no new breakpoint — `adapt, don't port`).
 *
 * It carries NO bespoke controls — everything is reused from portrait so the two viewports stay
 * consistent (David #86bb7phhh):
 *   - `ribbon`: the portrait `MCPlaybackRibbon` (Views · Filters · span/zoom · date-time+search chip →
 *     WhenSheet) rendered here for landscape and CSS-stacked vertically.
 *   - `nav`: the shared `MobileBottomNav` (Live / Playback / Setup) — same component + icons the portrait
 *     bottom nav uses, CSS-stacked vertically and pinned to the rail bottom.
 */
const MCPlaybackRail = ({ clock, body, nav }) => (
  <div className="mcpb-rail" data-testid="mcpb-rail">
    {/* System clock (David #86bb7phhh) — the shared RailClock, pinned to the top of the rail. */}
    {clock}

    {/* Grouped control body (David #86bb7phhh S25): MCPlaybackView composes it from ribbon/transport PARTS
        into three job-clusters ordered by importance top→bottom — WATCHING (View + Grid) · TIME (go-to-time
        + span) · REFINE/ACT (Filters + Bulk + Options). The rail is a thin shell; scrolls if it overflows. */}
    <div className="mcpb-rail__controls">{body}</div>

    <div className="mcpb-rail__nav">{nav}</div>
  </div>
);

export default MCPlaybackRail;
